import { Environment } from './env.interface';
import { environment as environmentPunksV1Mainnet } from './environment.punks-v1-mainnet';
import {
  LISTING_INDEXER_STAGING_GRAPHQL,
  LISTING_INDEXER_STAGING_NFTX_SCRAPER_BASE,
} from './listing-indexer-staging.urls';

/**
 * Staging build for CryptoPunks V1. Listing indexer and NFTX scraper hit staging;
 * other endpoints match production until overridden.
 */
export const environment: Environment = {
  ...environmentPunksV1Mainnet,
  env: 'punksv1:staging',
  production: true,
  debugMode: true,
  alternativeListingsGraphURI: LISTING_INDEXER_STAGING_GRAPHQL,
  nftxCustomScraperBaseURL: LISTING_INDEXER_STAGING_NFTX_SCRAPER_BASE,
  siteUrl: 'https://staging-v1.backend.v1cryptopunks.com',
  marketplaceUrl: 'https://staging-v1.v1cryptopunks.com',
  notifications: {
    ...environmentPunksV1Mainnet.notifications,
    apiUrl: 'https://staging-v1.xbot.v1cryptopunks.com',
  },
  featureFlags: {
    ...environmentPunksV1Mainnet.featureFlags,
    // Staging: exercise stash + on-chain dual bid flows (prod mainnet keeps stash off).
    STASH_BID_SUPPORT: true,
  },
};
